<template>
    <article v-if="id" :key="id" class="project-wrapper">
	    <WpLink class="project-block-link" v-if="postData" :title="postData.title.rendered" :url="postData.link" >
           
           <div class="project-inner">
                <div class="project-content">
                    <h3 class="posts-t" v-html="postData.title.rendered"></h3>
                    <p v-if="postData.acf" class="intro" v-html="postData.acf.facts.intro"></p>
                    
                </div>
                <div class="project-info">
						<div class="project-facts">
							<div class="facts-item">
								<p class="label" v-html="'Tidspunkt'"></p>
								<p v-if="postData.acf" v-html="postData.acf.facts.year"></p>
							</div>
							<div class="facts-item">
								<p class="label" v-html="'Sted'"></p>
								<p v-if="postData.acf" v-html="postData.acf.facts.place"></p>
							</div>
							<div class="facts-item">
								<Categories
										v-if="postData.acf && postData.acf._category" 
										:categories="postData.acf._category" :taxonomy="'projects_cat'" :link="false"/>
							</div>
						</div>
					</div>
            </div>

            <wpImage v-if="postImage"
                :data="postImage"
                size="medniu_large"
                class="bg-thumb"
                insideclass="picture_demension picture_demension--16x9"
                lazy
                background
                placeholder
            />
        </WpLink>
    </article>
    <div v-else class="single-event-block dummy">
        <div class="event-block-link">
            <div class="event-thumb"></div>
            <div class="event-footer ">
                <div class="column left">
                    <div class="dummy-text ">
                        <span></span>
                        <span></span>
                    </div>
                    <div class="dummy-tags ">
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div class="column right">
                    <div class="dummy-text ">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import WpImage from '@/components/elements/WpImage';
import Categories from '@/components/blocks/CategoriesBlock';
import WpLink from '@/components/elements/WpLink';



import { mapGetters } from 'vuex'

export default {
    name: 'block-single-project',
    props: ['id'],
    components:{
        WpImage,
        Categories,
        WpLink
    },
    computed: {
        ...mapGetters([
            'getPostById',
            'getPlaceholder'
        ]),
        postData(){
            let post = null;
            if(this.id){
                post = this.getPostById(this.id);
            }
            return post;
        },
        postImage(){
            const type = 'projects'
            return (this.postData && this.postData.featured_image_src) ? this.postData.featured_image_src : this.getPlaceholder(type);
        }
    },
};
</script>

<style lang="scss">
</style>
